const stringHelpers = {
  hTag: (term, level, separator, align) => {
    return term
      ? `<${level} role="heading" className="
          ${separator ? `separator-${align ? align : "left"}` : ""} 
          ${level}
          ${!separator && align ? `text-${align}` : ""}">${term}</${level}>`
      : "";
  },
  imagePathReplace: (text) => {
    const prependHost = process.env.NEXT_PUBLIC_IMG_PREFIX || "";
    const regex = /<img\b[^>]*\bsrc="\/uploads\/[^"]*"/g;
    return text.replace(regex, (match) => {
      if (match.includes("http")) {
        return match; // Already has the full URL, return as is
      } else {
        return match.replace("/uploads/", `${prependHost}/uploads/`);
      }
    });
  },
  objectToQueryParams: (obj, prefix = "") => {
    return Object.keys(obj)
      .map((key) => {
        const value = obj[key];
        const prefixedKey = prefix ? `${prefix}[${key}]` : key;

        if (typeof value === "object" && value !== null) {
          return stringHelpers.objectToQueryParams(value, prefixedKey); // Recursively build for nested objects
        } else {
          return `${encodeURIComponent(prefixedKey)}=${encodeURIComponent(
            value
          )}`;
        }
      })
      .join("&");
  },
};

export default stringHelpers;
